import { atom, selector, selectorFamily } from "recoil";
import { isNil } from "lodash-es";
import { DEFAULT_CURRENCY } from "../../constants/base";
import { THEME } from "../../constants/colors";
import { isBrowserEnv } from "@app/utils/constants";
import Cookies from "js-cookie";
import { parseCookie } from "@app/utils/cookie";

export const LocalCookieKey = "COINTR_LOCAL_COOKIE";
/***
 * cookie 字段
 */
export enum CookieKey {
  // 网站语言 默认 en
  LANG = "cointr_lang",
  // 折合货币单位  默认CNY
  UNIT = "cointr_unit",
  // 资产显示隐藏  默认 false
  SHOWASSET = "cointr_showasset",
  //资产折合估值单位
  VALUATIONUNIT = "cointr_valuationunit",
  // 交易区 主题 默认 dark
  THEME = "shark_theme",
  // 交易区 布局
  LAYOUT = "cointr_layout",
  // 模拟盘模式
  SIMULATION = "brand_simulation_trade",
}

const _default = {
  [CookieKey.LANG]: "en",
  [CookieKey.UNIT]: DEFAULT_CURRENCY, // 注意：该字段在使用中统一大写
  [CookieKey.SHOWASSET]: false,
  [CookieKey.THEME]: THEME.DARK,
  [CookieKey.VALUATIONUNIT]: 1,
  [CookieKey.LAYOUT]: "right",
  [CookieKey.SIMULATION]: false,
};

export const ssrUserCookiesState = atom({
  key: "ssr-user-cookies-state",
  // 默认值从cookie中获取
  default: isBrowserEnv ? parseCookie(Cookies.get(LocalCookieKey)) : null,
});

export const ssrThemeCookiesState = atom({
  key: "ssr-theme-cookies-state",
  // 默认值从cookie中获取
  default: isBrowserEnv ? Cookies.get(CookieKey.THEME) : null,
});

export const ssrUserCookiesSelector = selectorFamily({
  key: "ssr-user-cookies-selector",
  get:
    (key: CookieKey) =>
    ({ get }) => {
      const _cookies = get(ssrUserCookiesState);
      if (key === CookieKey.THEME) {
        return get(ssrThemeCookiesState);
      }
      return isNil(_cookies?.[key]) ? _default[key] : _cookies[key];
    },
});

// 模拟盘模式
export const ssrSimulationState = atom({
  key: "ssr-simulation-state",
  default: isBrowserEnv ? Cookies.get(CookieKey.SIMULATION) : null,
});

export const ssrSimulationSelector = selector({
  key: "ssr-simulation-selector",
  get: ({ get }) => get(ssrSimulationState),
  set: ({ set }, value) => {
    set(ssrSimulationState, value);
    if (isBrowserEnv) {
      Cookies.set(CookieKey.SIMULATION, value);
    }
  },
});
